export const STROKE_WIDTH_MIN = 0;

export interface TextStroke {
	enabled: boolean;
	color: string;
	width?: number;
}
